// 画面内にスクロールで入ってきた要素をフェードインさせるディレクティブ (v-fade-in)
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('fade-in-visible');
      observer.unobserve(entry.target);
    }
  });
}, {
  root: null,
  rootMargin: '0px 0px -10% 0px',
  threshold: 0.1,
});

export default {
  mounted(el) {
    el.classList.add('fade-in');
    observer.observe(el);
  },
  unmounted(el) {
    observer.unobserve(el);
  },
};
